<template>
  <div>
    <default-table
      :items="dados"
      :fields="campos"
      :striped="false"
      :busy="carregando"
      :tbody-tr-class="definirClasseLinha">
      <template #empty>
        <em>Nenhum registro encontrado.</em>
      </template>
      <template #cell(data)="row">
        {{ row.item.data_emissao | formatarData }}
      </template>
      <template #cell(valor)="row">
        {{ row.item.valor_total | formatarValorMonetario }}
      </template>
      <template #cell(servico)="row">
        <slot name="servico" :item="row.item" />
      </template>
      <template #cell(acoes)="row">
        <slot name="acoes" :item="row.item" />
      </template>
    </default-table>
  </div>
</template>

<script>
import ListagemPedidos from './js/listagem-pedidos'
export default ListagemPedidos
</script>

<style scoped>
@import "./scss/pedidos.scss";
</style>
